<template>
    <el-dialog title="新建项目模板" :visible.sync="currentValue" width="590px" custom-class="reset-password-dialog" :close-on-click-modal="false"
    :append-to-body="true">
      <el-form class="my-form" ref="form" :model="form" :rules="rules" size="large" label-position="top">
        <el-form-item label="项目模板名称" prop="template_name">
          <el-input ref="input" type="text" placeholder="请输入项目模板名称" v-model="form.template_name" clearable maxlength="100">>
          </el-input>
        </el-form-item>
      </el-form>
       <span slot="footer" class="dialog-footer">
        <div></div>
        <div class="footer-right">
          <span class="text-btn-active" @click="currentValue = false" style="margin-right: 24px;">取消</span>
          <wf-button type="primary" @click="onSubmit" :disabled="isDisabled" :loading="loading">创建</wf-button>
        </div>
      </span>
    </el-dialog>
</template>
<script>
import api from '@/services/api/template'
export default {
  props: {
    value: Boolean,
  },
  data() {
    return {
      form: {
        template_name: ''
      },
      rules: {
        title: [
          { required: true, trigger: "change", message: "项目模板名称不能为空" },
        ],
      },
      loading: false
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.input.focus()
    })
  },
  computed: {
    currentValue: {
      get: function () {
        return this.value || undefined;
      },
      set: function (newValue) {
        this.$emit('input', newValue || null)
      }
    },
    isDisabled() {
      return !this.form.template_name
    }
  },
  methods: {
    onSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          await api.projectTemplatesSave({template_name: this.form.template_name})
          this.$message({
            message: '创建模板成功',
            type: 'success'
          })
          this.$emit('success')
        }
      })
    }
  },
}
</script>
